import BaseEnumType from "../../common/base-enum-type";

const PersonnelRole = Object.freeze({
    Referee: new BaseEnumType("referee", "Referee"),
    Umpire: new BaseEnumType("umpire", "Umpire"),
    DownJudge: new BaseEnumType("downJudge", "Down Judge"),
    LineJudge: new BaseEnumType("lineJudge", "Line Judge"),
    SideJudge: new BaseEnumType("sideJudge", "Side Judge"),
    BackJudge: new BaseEnumType("backJudge", "Back Judge"),
    FieldJudge: new BaseEnumType("fieldJudge", "Field Judge"),
    Timer: new BaseEnumType("timer", "Timer"),
    PlayClockOperator: new BaseEnumType(
        "playClockOperator",
        "Play Clock Operator"
    ),
    OfficialScorer: new BaseEnumType("officialScorer", "Official Scorer"),
    Statistician: new BaseEnumType("statistician", "Statistician")
});

export default PersonnelRole;
